export default __webpack_public_path__ + "a72649dd4a92433a22b3ba24b964cac4.png";